import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const slotList = createAsyncThunk('slotList', async ({ pageable: data, navigate, status }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `slot?status=${status || ''}`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const slotListSlice = createSlice({
    name: 'slotList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(slotList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = (() => {
                    const raw = action.payload.data.data;
                    return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []);
                })();
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(slotList.rejected, (state, action) => {
        })
    }
})

export default slotListSlice.reducer;
